import $ from "jquery";
import { messageEllipse, messagefromSystem, initBotInstance, messagefromBot } from "#scripts/dialog/dialog_messages.js";
import { getConfig, isMobile } from "#scripts/general_functions.js";
import dayjs from "dayjs";
import { setAccordian } from "#scripts/accordian.js";
import kariavatar from "#scripts/kariavatar";

import language from "#scripts/translation";

export const chatFocus = (bg = true, buttons = true) => {
	if (bg === true) {
		$(".chatbot-search").addClass("transform-bg");
		$(".dialog__avatarcontainer").addClass("dialogongoing");
	} else {
		$(".chatbot-search").removeClass("transform-bg");
	}
	if (buttons === true) {
		$(".chatbot-search").addClass("show-actions");
	} else {
		$(".chatbot-search").removeClass("show-actions");
	}
};

export const setScrollBottom = () => {
	if ($("#chatbot__container").hasClass("chatbot__mobile-show")) {
		const element = document.getElementById("chatbot__messagearea");
		element.scrollTop = element.scrollHeight;
		window.scrollTo(0, document.body.scrollHeight);

		$("body").addClass("overflow-hidden");
		$("main").hide();
		$("footer").hide();
		$(".navbar").hide();
		$(".warnings").hide();
	} else {
		const chatContainer = document.querySelector(".chatbot-search--container");
		chatContainer.scrollTop = chatContainer.scrollHeight;
	}
};

export const conversationPrint = () => {
	const currentConversation = sessionStorage.getItem("conversationHtml");
	if (currentConversation) {
		$("#kari__dialog__window").html(`<div class='dialog__history'>${currentConversation}</div>`);
	}

	setAccordian();
};

export const deleteDialog = () => {
	window.scrollTo(0, 0);

	$("#kari__dialog__window").html("");

	messageEllipse();
	messagefromSystem(language("DELETE_ALL_TRACKS"));

	setTimeout(() => {
		$(".removewhendone").remove();

		messagefromSystem(language("CONVERSATION_DELETED"));
		messagefromSystem("", "seperator");

		sessionStorage.removeItem("conversation");
		sessionStorage.removeItem("chat_sessionid");
		sessionStorage.removeItem("conversationHtml");

		initBotInstance();
	}, 1000);

	const body = { command: "DELETE" };

	if (sessionStorage.getItem("chat_sessionid") && sessionStorage.getItem("chat_sessionid").length > 0) {
		body.conversation_id = sessionStorage.getItem("chat_sessionid");
	}

	fetch("//007prokom.boost.ai/api/chat/v2", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	}).then((res) => {

	});
};

export const restartDialog = () => {
	window.scrollTo(0, 0);

	messageEllipse();

	setTimeout(() => {
		$(".removewhendone").remove();

		messagefromSystem("", "seperator");

		sessionStorage.removeItem("conversation");
		sessionStorage.removeItem("chat_sessionid");
		sessionStorage.removeItem("conversationHtml");

		initBotInstance();
	}, 500);
};

export const hideChat = (state = true) => {
	const config = getConfig();
	const convHtml = sessionStorage.getItem("conversationHtml") || "";

	const startKariChat = () => {
		if (isMobile()) {
			// messagefromSystem(language("CHAT_INTROMSG_3"), "html", true, "dialog__start first");
			messagefromSystem(language("INTRO_QUESTION"), "html", true, "dialog__start first");
			$(".chatbot__container").addClass("chatbot__mobile");
		} else {
			// false for not mobile device
			// messagefromSystem(language("CHAT_INTROMSG_1"), "html", true, "dialog__start first");
			// messagefromSystem(language("CHAT_INTROMSG_2"), "html", true, "dialog__start");
			// messagefromSystem(language("CHAT_INTROMSG_3"), "html", true, "dialog__start");

			let msgnr = 0;
			const skip = Number.parseInt(window.serverdata.configMeta.aim.kariSkipStartMessages);
			const fromKari = JSON.parse(sessionStorage.getItem("chat_initialresponse"));
			$.each(fromKari, (a, b) => {
				const msgNrClass = msgnr === 0 ? "dialog__start first" : "dialog__start";
				if (skip - 1 !== msgnr) {
					messagefromSystem(b, b.type, true, msgNrClass);
				}
				// setScrollBottom();
				msgnr++;
			});
		}
	};

	if (state === true) {
		$("#kari__dialog__window").empty();

		if (config.template !== "frontpage") {
			$(".chatbot-search").addClass("condensed continue");
			$(".dialog__avatarcontainer").addClass("dialog__avatarcontainer-condensed dialog__avatarcontainer-continue");
			const kari = kariavatar();
			// if (!isMobile()) {
			if (window?.kariAnimator?.waveSvgHtml !== undefined) {
				$(".dialog__avatarcontainer")[0].innerHTML = window?.kariAnimator?.waveSvgHtml;
			} else {
				$(".dialog__avatarcontainer")[0].innerHTML = kari;
			}
			// }
			chatFocus(true, false);
			if (convHtml.length > 0) {
				$(".dialog__input").attr("placeholder", language("CONTINIUE_CONVERSATION"));
			} else {
				$(".dialog__input").attr("placeholder", language("START_OR_SEARCH"));
			}
			window.scrollTo(0, 0);
		} else if ($(convHtml).find(".dialog__fromkari").length > 3) {
			$(".chatbot-search").addClass("continue");
			$(".dialog__avatarcontainer").addClass("dialog__avatarcontainer-continue");
			chatFocus(false, false);

			$(".dialog__input").attr("placeholder", language("CONTINIUE_CONVERSATION"));
			window.scrollTo(0, 0);
		} else if ($(convHtml).find(".dialog__fromkari").length === 3) {
			chatFocus(false, false);

			startKariChat();
		} else {
			// $(".chatbot-search").addClass("continue");
			chatFocus(false, false);
			if ($(".dialog__fromkari.dialog__start").length < 1) {
				startKariChat();
			}
		}
	} else {
		chatFocus();
		$(".chatbot-search").removeClass("condensed continue");
		$(".dialog__avatarcontainer").removeClass("dialog__avatarcontainer-condensed dialog__avatarcontainer-continue");
		$(".dialog__input").attr("placeholder", "");
		conversationPrint();
		setScrollBottom();
	}
};

export const createAddDislike = (obj) => {
	$("#kari__dialog__window").append(
		messagefromBot({
			type: "vote",
			html: `
        <div class='dialog__feedback__buttons text-right'>
            <button data-id="${obj.response.id}" data-value="positive" class="btn btn-light dialog__feedback__button dialog__feedback__button--positive" aria-label="Liker"><span class="material-icons-outlined notranslate">thumb_up</span></button>
            <button data-id="${obj.response.id}" data-value="negative" class="btn btn-light dialog__feedback__button dialog__feedback__button--negative" aria-label="Missliker"><span class="material-icons-outlined notranslate">thumb_down</span></button>
        </div>`,
		}),
	);

	setScrollBottom();
};

export const deleteOnInactivity = () => {
	if (Number.parseInt(sessionStorage.getItem("lastmessage")) < dayjs().subtract(1, "minute").valueOf()) {
		$("#kari__dialog__window").html("");

		messageEllipse();
		messagefromSystem(language("INACTIVE_DELETION"));

		$(".removewhendone").remove();

		messagefromSystem("", "seperator");

		sessionStorage.removeItem("conversation");
		sessionStorage.removeItem("chat_sessionid");
		sessionStorage.removeItem("conversationHtml");

		initBotInstance();
	}
};

export const getMetaValue = (metaobj, key) => {
	if (typeof metaobj !== "object") return false;
	const matches = [];
	$.each(metaobj, (a, b) => {
		if (b.name === key) {
			matches.push(b.value);
		}
	});
	if (matches.length === 1) return matches[0];
	return matches;
};
